export abstract class Failure {
  protected constructor(public code: string, public message: string) {}

  public is(code: string): boolean {
    return code === this.code;
  }
}
